import PropTypes from 'prop-types';
import { Icon, ScreenReaderPrice } from '@eti/components';
import Media from 'react-media';
import { css, etiColors, mediaQueries } from '@eti/styles';
import { Button, Label, Price, VerticalContainer } from './styles/quickSortButton';

const iconStyles = css`
  height: 24px;
  width: 24px;

  @media ${mediaQueries.large.up} {
    height: 32px;
    width: 32px;
  }
`;

const selectedStyles = css`
  background-color: ${etiColors.info.light};
  border: 1px solid ${etiColors.info.solid};
  border-left: 1px solid ${etiColors.info.solid};
  border-right: 1px solid ${etiColors.info.solid};
  color: ${etiColors.info.solid};

  span {
    color: ${etiColors.info.solid};
  }

  path[fill='${etiColors.grayScale[8]}'] {
    fill: ${etiColors.info.solid};
  }

  & + button {
    border-left: none;
  }

  html[dir='rtl'] & {
    border-right: 1px solid ${etiColors.info.solid};
    & + button {
      border-right: 1px solid ${etiColors.info.solid};
    }
  }
`;

const QuickSortButton = ({ formattedPrice, icon, id, type, isSelected, label, onClick }) => {
  const handleClick = () => !isSelected && onClick(type);

  return (
    <Media query={mediaQueries.medium.up}>
      {(isMediumScreen) => (
        <Button
          className={isSelected && selectedStyles}
          color={etiColors.info.solid}
          data-testid="result-quick-sort-button"
          id={id}
          isSelected={isSelected}
          onClick={handleClick}
        >
          {isMediumScreen && (
            <Icon
              className={iconStyles}
              color={isSelected ? etiColors.info.solid : etiColors.grayScale[7]}
              id={icon}
            />
          )}
          <VerticalContainer>
            <Label>{label}</Label>
            <Price aria-hidden>{formattedPrice}</Price>
            <ScreenReaderPrice price={formattedPrice} />
          </VerticalContainer>
        </Button>
      )}
    </Media>
  );
};

QuickSortButton.propTypes = {
  formattedPrice: PropTypes.string,
  icon: PropTypes.string,
  id: PropTypes.string,
  isSelected: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
};

export default QuickSortButton;
